import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, Card, WingBlank, WhiteSpace, Picker, List, Calendar } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import { createForm } from 'rc-form';
import CommonUtils from '../utils/CommonUtils';
import '../styles/DeviceRevenuePage.css';

const history = require("history").createHashHistory()
class DeviceRevenuePage extends Component {
    static defaultProps = {
        fetchSites: (params, callback) => {},
        fetchRevenue: (params, callback) => {},
        fetchDeviceTypes: (params, callback) => {},
        defaultSiteId: null
    }

    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.defaultSiteId = this.props.defaultSiteId
        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            selectedItem: null,
            sites: [],
            selectedSite: this.defaultSiteId,
            showCalendar: false,
            dateRange: {
                start: new Date(),
                end: new Date()
            },
            deviceType: '',
            deviceTypes: []
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 170;
        this.setState({
            height
        })
        this.loadInitData()
    }

    loadInitData = () => {
        this.loadSites(() => {
            this.loadPageData()
        })
        this.loadDeviceTypes()
    }

    loadPageData = () => {
        const { selectedSite, dateRange, deviceType } = this.state
        const params = {
            siteId: selectedSite,
            fromDate: CommonUtils.formatDate(dateRange.start),
            toDate: CommonUtils.formatDate(dateRange.end),
            deviceType
        }

        this.props.fetchRevenue(params, (resp) => {
            let data = resp.data
            this.pageNum = 1;
            this.pages = 1;
            this.rowDatas = {...this.wrapIntoRowDatas(data)};
            this.setState({
                dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                isLoading: false,
                hasMore: this.pageNum < this.pages
            })
        })
    }

    loadSites = (callback) => {
        this.props.fetchSites({}, (resp) => {
            let selectedSite
            if(resp.data && resp.data.length) {
                if(CommonUtils.isEmpty(this.defaultSiteId)) {
                    selectedSite = resp.data[0].id
                } else {
                    for(let item of resp.data) {
                        if(this.defaultSiteId === item.id) {
                            selectedSite = item.id
                            break
                        }
                    }
                }
                if(CommonUtils.isEmpty(selectedSite)) {
                    selectedSite = resp.data[0].id
                }
            }
            
            this.setState({
                sites: resp.data,
                selectedSite,
            }, () => {
                callback&&callback()
            })
        })
    }

    loadDeviceTypes = () => {
        this.props.fetchDeviceTypes({}, (resp) => {
            this.setState({
                deviceTypes: resp.data
            })
        })
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    onSitePickerChange = (val) => {
        this.setState({
            selectedSite: val[0]
        }, () => {
            this.loadPageData()
        })
    }

    onDeviceTypePickerChange = (val) => {
        this.setState({
            deviceType: val[0]
        }, () => {
            this.loadPageData()
        })
    }

    onCalendarConfirm = (startDate, endDate) => {
        this.setState({
            showCalendar: false,
            dateRange: {
                start: startDate,
                end: endDate
            }
        }, () => {
            this.loadPageData()
        })
    }

    onCalendarCancel = () => {
        this.setState({
            showCalendar: false
        })
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    renderRow = (rowData, sectionId, rowId) => {
        let extra = (<div><span className='unit'>￥</span><span className='value'>{rowData.profitAmount}</span></div>)
        return (
            <WingBlank size='sm'>
                <div>
                    <Card key={rowId}>
                        <Card.Header
                            title={<span className='word-ellipsis'>{rowData.deviceName?rowData.deviceName:rowData.deviceId}</span>}
                            extra={extra}
                        />
                        <Card.Body>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>设备类型：</span> 
                                    <span className='value'>{CommonUtils.resolveDictText(rowData.deviceType, this.state.deviceTypes, 'code', 'name')}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>成交订单：</span> 
                                    <span className='value'>{rowData.dealPacketCount}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>充值单数：</span> 
                                    <span className='value'>{rowData.dealRechargeCount}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>退款单数：</span> 
                                    <span className='value'>{rowData.dealRefundCount}</span>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderFilterView = () => {
        const { sites, selectedSite, dateRange, deviceType, deviceTypes } = this.state;
        const sitePickerData = sites.map(item => ({value: item.id, label: item.siteName}))
        const deviceTypePickerData = CommonUtils.generatePickerOptionsFromList(deviceTypes, 'code', 'name')
        return (
            <div className='wrapper-filter'>
                <WingBlank size='sm'>
                    <Picker 
                        cols={1}
                        value={[selectedSite]}
                        onOk={this.onSitePickerChange}
                        data={[...sitePickerData]}>
                        <List.Item arrow="horizontal" className='title'>
                            <i className='iconfont icon-guolv'/>
                            <span> 筛选</span>
                        </List.Item>
                    </Picker>
                    <div className='filters'>
                        <div className='date-range-picker' onClick={() => {
                            this.setState({
                                showCalendar: true
                            })
                        }}>
                            <span className='symbol'>
                                <i className='iconfont icon-rili'/>
                            </span>
                            <span className='date'>{CommonUtils.formatDate(dateRange.start)}</span>
                            <span className='seperator'>~</span>
                            <span className='date'>{CommonUtils.formatDate(dateRange.end)}</span>
                        </div>
                        <div className='device-type-picker'>
                            <Picker
                                cols={1}
                                value={[deviceType?deviceType:'']}
                                onOk={this.onDeviceTypePickerChange}
                                data={[{label:'所有设备', value: ''}, ...deviceTypePickerData]}>
                                <List.Item></List.Item>
                            </Picker>
                        </div>
                    </div>
                </WingBlank>
            </div>
        )
    }

    render() {
        const { dataSource, isLoading, showCalendar, dateRange } = this.state;

        return (
            <div className='device-revenue-page'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                >
                    设备收益
                </NavBar>
                {this.doRenderFilterView()}
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 170
                    }}
                />
                <Calendar
                    visible={showCalendar}
                    showShortcut={true}
                    initalMonths={12}
                    infinite={false}
                    onCancel={this.onCalendarCancel}
                    onConfirm={this.onCalendarConfirm}
                    defaultValue={[dateRange.start, dateRange.end]}
                    maxDate={new Date()}
                />
            </div>
        )
    }
}

export default createForm()(DeviceRevenuePage);


// WEBPACK FOOTER //
// ./src/components/DeviceRevenuePage.js